import { AffiliateInfoComponent } from './../../components/affiliate-info/affiliate-info';
import { ModalController, LoadingController } from 'ionic-angular';
import { Promoter } from './../../models/FirstPromoter';
import { UserProvider } from './../user/user';
import { Injectable } from '@angular/core';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { BtBackendProvider } from '../bt-backend/bt-backend';
import { ToastService } from '../util/toast.service';

/*
  Generated class for the FirstPromoterProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class FirstPromoterProvider {

  public loaded: boolean = false;
  public URL: string = null;

  constructor(
    public userCtrl: UserProvider,
    public iab: InAppBrowser,
    public modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    public backend: BtBackendProvider,
    public toastCtrl: ToastService
  ) {
    this.userCtrl.getPromoter().subscribe(promoter => {
      if(promoter){
        this.URL = this.getURL(promoter);
      }else{
        this.URL = null;
      }
      this.loaded = true;
    }, error => {
      console.log(error);
    });
  }


  public goToPromoter(){
    let loader = this.loadingCtrl.create();
    loader.present();
    this.userCtrl.getPromoter().first().subscribe(promoter => {
      if(promoter){
        this.URL = this.getURL(promoter);
        this.openDashboard();
      }else{
        this.URL = null;
        this.openPromo();
      }
      this.loaded = true;
      loader.dismiss();
    }, error => {
      loader.dismiss();
      console.log(error);
    });
    
  }

  private getURL(promoter: Promoter): string{
    if(promoter && promoter.auth_token){
      return `https://blocktistics.firstpromoter.com/iframe?at=${promoter.auth_token}`
    }else{
      return null;
    }
  }

  private openPromo(){
    let modal = this.modalCtrl.create(AffiliateInfoComponent);
    modal.present();
  }

  private openDashboard(){
    let browser = this.iab.create(this.URL);
    browser.show();
  }

  public createPromoter(){
    let loader = this.loadingCtrl.create();
    loader.present();
    this.backend.createPromoter().first().subscribe(response => {
      loader.dismiss();
      this.toastCtrl.create({message: `Done! Head back to the Rewards section to visit your promoter dashboard.`, ok: true, duration: 2000});
    }, error => {
      loader.dismiss();
      this.toastCtrl.create({message: 'Your email is already in the FirstPromoter system. Try logging in at blocktistics.firstpromoter.com with your passowrd.', ok: true, duration: 2000});
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/first-promoter/first-promoter.ts